import { render, staticRenderFns } from "./order-info.vue?vue&type=template&id=31fb8dd8&scoped=true&"
import script from "./order-info.vue?vue&type=script&lang=js&"
export * from "./order-info.vue?vue&type=script&lang=js&"
import style0 from "./order-info.vue?vue&type=style&index=0&id=31fb8dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb8dd8",
  null
  
)

export default component.exports